import type {Trace} from '../trace/type'
import type {LogValueNode} from '../type'

const SESSION_KEY = 'web-console-traces'

const isLogValueNode = (item: unknown): item is LogValueNode =>
    typeof item === 'object' &&
    item !== null &&
    typeof (item as LogValueNode).type === 'string' &&
    typeof (item as LogValueNode).preview === 'string'

const isTrace = (item: unknown): item is Trace =>
    typeof item === 'object' &&
    item !== null &&
    typeof (item as Trace).id === 'string' &&
    typeof (item as Trace).scope === 'string' &&
    typeof (item as Trace).timestamp === 'number' &&
    Array.isArray((item as Trace).message) &&
    (item as Trace).message.every(isLogValueNode)

export const getTracesFromSession = (): Trace[] => {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY)
        if (!raw) {
            return []
        }
        const parsed: unknown = JSON.parse(raw)
        if (!Array.isArray(parsed)) {
            return []
        }
        return parsed.filter(isTrace)
    } catch {
        return []
    }
}

export const setTracesToSession = (traces: Trace[]): void => {
    try {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(traces))
    } catch {}
}

export const clearTracesFromSession = (): void => {
    try {
        sessionStorage.removeItem(SESSION_KEY)
    } catch {}
}
